'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookLoma = require('@narvar/nth-hook-loma');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var ResizableMap = require('./ResizableMap.js');
var graphql = require('./graphql.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const MaptilerMap = ({
  coordinates,
  featureName,
  layout = FeatureLayout.PORTRAIT,
  s = {
    height: '20rem',
    width: '20rem'
  }
}) => {
  const {
    data
  } = nthHookLoma.useMaptilerQuery();
  const key = data && data.maptiler && data.maptiler.key || '';
  const {
    lng,
    lat
  } = coordinates || {};
  const {
    state: {
      orderNumbers
    }
  } = nthHookContextPage.usePageContext();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    logEvent({
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_MAPTILER_MAP,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_MAPTILER_MAP,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      orderNumber: orderNumbers && orderNumbers[0],
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_MAPTILER_MAP,
      pageOrderNumber: orderNumbers && orderNumbers[0],
      trackLayout: layout
    });
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  if (!(coordinates && typeof lng === 'number' && typeof lat === 'number' && key)) return null;
  return /*#__PURE__*/React__default["default"].createElement(ResizableMap["default"], {
    coordinates: {
      lat,
      lng
    },
    maptilerKey: key,
    s: s
  });
};

exports.maptilerQuery = graphql["default"];
exports["default"] = MaptilerMap;
